import { http, HttpResponse } from 'msw';
import { mockTruktTmsApiUrl } from '../mocks';
import { OrderClassificationSearchResponse } from '../services/OrderClassificationService';

export const handlers = [
  http.get(mockTruktTmsApiUrl('/orders/classifications'), () => {
    return HttpResponse.json<OrderClassificationSearchResponse>({
      rows: 100,
      page: 0,
      total: 5,
      results: [
        {
          id: '4',
          label: 'car haul',
          isDefault: false,
        },
        {
          id: '5',
          label: 'drayage',
          isDefault: false,
        },
        {
          id: '1',
          label: 'freight',
          isDefault: false,
        },
        {
          id: '2',
          label: 'repossession',
          isDefault: false,
        },
        {
          id: '3',
          label: 'salvage',
          isDefault: false,
        },
      ],
    });
  }),
];
